import { BuiltInTooltip } from './types';
import useIsPrinting from '../../../utilities/PrintUtilities';

export function GetTooltip({ chartDef, timeslice }) {
    const isPrinting = useIsPrinting();
    const tooltip = chartDef?.tooltip || BuiltInTooltip;

    if (isPrinting) return null;

    return tooltip({ chartDef, timeslice });
}
